module.exports = __webpack_public_path__ + "media/common/icon-weather-clear-nighttime-5238ee36.svg";